module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgements"
    }
  }, [_c('h1', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I would like to express my deepest gratitude to Professor Abdelkrim Berrah for his unwavering support, collegiality and mentorship throughout this journey.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I want to thank my wife, Saliha, and my wonderful children, Asmaa, Imane, Soumaia, Ahmed, Isra and Dania, who mean")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("everything to me. Thank you for your patience, enthusiasm and support.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I would like to thank my parents, who were very proud of me. No kid could have been loved or supported more.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I want to thank also my brothers: Nacer, Abdelkader, Ahmed and Fouad, as well as my cousins Saad Haouimi, Larbi Dekoumi and my friend Professor Samir Rouabhia Head and Chairman Department of Internal Medicine CHU Benflis, Batna, Algeria.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A big thanks to all staff of the Medical Imaging Center “Aures”, Samia Hocine, Assia Kendri, Karima Chennaf, Rahima Bougouffa, Khoukha Bouzidi, Houssem-eddine Kouachi, Mustapha Benguiba, Mustapha Aoura, Atef Bouguelaa, Nadia Bouzenag, Amar Gasmi, Mohamed Gasmi, Bouguelaa M’hammed and Allouache Salah.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Finally, I would like to express my gratitude to Mr David Learner, executive editor and Mr Vinh Tran, production coordinator at Austin Macauley Publishers Ltd, London (United Kingdom).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Ammar Haouimi ")]), _c('br'), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I would like to pay special thanks and appreciation to the many people who offered help and support at various stages in")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("my life.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A special thanks to my colleague Doctor Ammar Haouimi for his patience, help and collaboration, without him this book may not have been completed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Finally, I want to thank my family members for their vital support and love. Without them I could never have achieve my goals.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Rabah Bouguelaa")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0